import React from "react";
import { MenuItem } from "react-bootstrap";
//--
export class FilterOption extends React.Component {
    render() {
        let { keyName, filterCallback, displayName } = this.props;
        return (React.createElement(MenuItem, { eventKey: keyName, key: keyName, onClick: (e) => { e.stopPropagation(); }, onMouseUp: (e) => { filterCallback(); } }, displayName));
    }
}
